import { render, staticRenderFns } from "./UnAuthPage.vue?vue&type=template&id=1db0f35c&scoped=true&"
import script from "./UnAuthPage.vue?vue&type=script&lang=ts&setup=true&"
export * from "./UnAuthPage.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./UnAuthPage.vue?vue&type=style&index=0&id=1db0f35c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1db0f35c",
  null
  
)

export default component.exports